import script from "./HolidayList.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayList.vue?vue&type=script&setup=true&lang=js"

import "./HolidayList.vue?vue&type=style&index=0&id=7bae57f2&lang=css"

const __exports__ = script;

export default __exports__